import { Component, Input, OnInit } from '@angular/core';
import { UsersService } from '../users/users.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { getUserDetailsSelector } from '../../shared/user/user.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cc-dont-accept-incoming-calls',
  templateUrl: './dont-accept-incoming-calls.component.html',
  styleUrls: ['./dont-accept-incoming-calls.component.scss']
})
export class DontAcceptIncomingCallsComponent implements OnInit {
  @Input() dashboardName: string;
  @Input() userId: number;
  @Input() username: string;
  @Input() dontAcceptIncomingCalls: boolean;
  public hasPermissionToSwitchStatus: boolean;

  constructor(
    private usersService: UsersService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private permissionsService: NgxPermissionsService,
    private amplitudeService: AmplitudeService,
    private store: Store<IState>
  ) {}

  ngOnInit() {
    this.permissionsService
      .hasPermission('EDIT_USER_PERMISSION')
      .then(result => (this.hasPermissionToSwitchStatus = result));
  }

  switchOnDontAcceptIncomingCalls() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'USERS.SWITCH_ON_DONT_ACCEPT_INCOMING_CALLS_TITLE',
          body: 'USERS.SWITCH_ON_DONT_ACCEPT_INCOMING_CALLS_INFO'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changeDontAcceptIncomingCallsStatus();
        }
      });
  }

  switchOffDontAcceptIncomingCalls() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'USERS.SWITCH_OFF_DONT_ACCEPT_INCOMING_CALLS_TITLE',
          body: 'USERS.SWITCH_OFF_DONT_ACCEPT_INCOMING_CALLS_INFO'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.changeDontAcceptIncomingCallsStatus();
        }
      });
  }

  changeDontAcceptIncomingCallsStatus() {
    this.usersService.setBlockingIncomingCalls(this.userId, !this.dontAcceptIncomingCalls).subscribe(() => {
      this.dontAcceptIncomingCalls = !this.dontAcceptIncomingCalls;
      this.translate.get('CHANGES_SAVED').subscribe((res: string) => {
        this.store.select(getUserDetailsSelector).subscribe(details => {
          this.amplitudeService.logEvent('Do not disturb', {
            status: this.dontAcceptIncomingCalls ? 'on' : 'off',
            source: `${this.dashboardName} dashboard`,
            by: details.username,
            to: this.username
          });
        });
        this.toastr.success(res);
      });
    });
  }
}
